/**
 * EcomLab Theme — License Enforcement
 * elxr-license.js
 * 
 * Flow:
 *  1. Skip in Shopify theme editor (design mode)
 *  2. Check localStorage cache (24h TTL)
 *  3. If cache miss/expired → call API with HMAC signature
 *  4. Cache result → show overlay if invalid
 * 
 * Do not modify this file. Tampering triggers automatic invalidation.
 */
(function () {
  'use strict';

  // ── Config ────────────────────────────────────────────────────────────────
  var CFG = {
    api: (window.EcomLab && window.EcomLab.apiBase) || 'https://theme.brainboxecomlab.com/api',
    cacheTTL: 86400000,       // 24 hours
    graceTTL: 604800000,      // 7 days offline grace
    retryDelay: 3000,
    maxRetries: 2,
    overlayDelay: 800,        // ms before showing overlay (avoids flash on valid stores)
  };

  // ── Bail in editor ────────────────────────────────────────────────────────
  if (window.Shopify && window.Shopify.designMode) return;
  if (document.documentElement.classList.contains('shopify-design-mode')) return;

  // ── Read globals ──────────────────────────────────────────────────────────
  var LICENSE_KEY = (window.EcomLab && window.EcomLab.licenseKey) || '';
  var SHOP        = (window.EcomLab && window.EcomLab.shop)       || '';
  var CACHE_KEY   = 'elxr_lic_' + SHOP;

  // ── HMAC-SHA256 (pure JS, no crypto dependency) ───────────────────────────
  function hmacSHA256(key, message) {
        function strToBytes(s) {
      var bytes = [];
      for (var i = 0; i < s.length; i++) {
        var c = s.charCodeAt(i);
        if (c < 128) { bytes.push(c); }
        else if (c < 2048) { bytes.push((c >> 6) | 192, (c & 63) | 128); }
        else if (c < 65536) { bytes.push((c >> 12) | 224, ((c >> 6) & 63) | 128, (c & 63) | 128); }
        else { bytes.push((c >> 18) | 240, ((c >> 12) & 63) | 128, ((c >> 6) & 63) | 128, (c & 63) | 128); }
      }
      return bytes;
    }

    function sha256(data) {
      var K = [
        0x428a2f98,0x71374491,0xb5c0fbcf,0xe9b5dba5,0x3956c25b,0x59f111f1,0x923f82a4,0xab1c5ed5,
        0xd807aa98,0x12835b01,0x243185be,0x550c7dc3,0x72be5d74,0x80deb1fe,0x9bdc06a7,0xc19bf174,
        0xe49b69c1,0xefbe4786,0x0fc19dc6,0x240ca1cc,0x2de92c6f,0x4a7484aa,0x5cb0a9dc,0x76f988da,
        0x983e5152,0xa831c66d,0xb00327c8,0xbf597fc7,0xc6e00bf3,0xd5a79147,0x06ca6351,0x14292967,
        0x27b70a85,0x2e1b2138,0x4d2c6dfc,0x53380d13,0x650a7354,0x766a0abb,0x81c2c92e,0x92722c85,
        0xa2bfe8a1,0xa81a664b,0xc24b8b70,0xc76c51a3,0xd192e819,0xd6990624,0xf40e3585,0x106aa070,
        0x19a4c116,0x1e376c08,0x2748774c,0x34b0bcb5,0x391c0cb3,0x4ed8aa4a,0x5b9cca4f,0x682e6ff3,
        0x748f82ee,0x78a5636f,0x84c87814,0x8cc70208,0x90befffa,0xa4506ceb,0xbef9a3f7,0xc67178f2
      ];
      var H = [0x6a09e667,0xbb67ae85,0x3c6ef372,0xa54ff53a,0x510e527f,0x9b05688c,0x1f83d9ab,0x5be0cd19];

      function rotr(x, n) { return (x >>> n) | (x << (32 - n)); }
      function add32() {
        var s = 0;
        for (var i = 0; i < arguments.length; i++) s = ((s + arguments[i]) >>> 0);
        return s;
      }

      // Pre-process
      var len = data.length;
      data.push(0x80);
      while (data.length % 64 !== 56) data.push(0);
      var bitLen = len * 8;
      var bits = [];
      for (var i = 0; i < 8; i++) {
        bits.unshift(bitLen & 0xff);
        bitLen = Math.floor(bitLen / 256);
      }
      data = data.concat(bits);

      for (var i = 0; i < data.length; i += 64) {
        var W = [];
        for (var j = 0; j < 16; j++)
          W[j] = (data[i+j*4]<<24)|(data[i+j*4+1]<<16)|(data[i+j*4+2]<<8)|data[i+j*4+3];
        for (var j = 16; j < 64; j++) {
          var s0 = rotr(W[j-15],7)^rotr(W[j-15],18)^(W[j-15]>>>3);
          var s1 = rotr(W[j-2],17)^rotr(W[j-2],19)^(W[j-2]>>>10);
          W[j] = add32(W[j-16], s0, W[j-7], s1);
        }
        var a=H[0],b=H[1],c=H[2],d=H[3],e=H[4],f=H[5],g=H[6],h=H[7];
        for (var j = 0; j < 64; j++) {
          var S1 = rotr(e,6)^rotr(e,11)^rotr(e,25);
          var ch = (e&f)^(~e&g);
          var temp1 = add32(h, S1, ch, K[j], W[j]);
          var S0 = rotr(a,2)^rotr(a,13)^rotr(a,22);
          var maj = (a&b)^(a&c)^(b&c);
          var temp2 = add32(S0, maj);
          h=g; g=f; f=e; e=add32(d,temp1); d=c; c=b; b=a; a=add32(temp1,temp2);
        }
        H[0]=add32(H[0],a); H[1]=add32(H[1],b); H[2]=add32(H[2],c); H[3]=add32(H[3],d);
        H[4]=add32(H[4],e); H[5]=add32(H[5],f); H[6]=add32(H[6],g); H[7]=add32(H[7],h);
      }
      return H;
    }

    // Pad key
    var keyBytes = strToBytes(key);
    if (keyBytes.length > 64) {
      var hk = sha256(keyBytes.slice());
      keyBytes = [];
      for (var i=0;i<8;i++){
        keyBytes.push((hk[i]>>>24)&0xff,(hk[i]>>>16)&0xff,(hk[i]>>>8)&0xff,hk[i]&0xff);
      }
    }
    while (keyBytes.length < 64) keyBytes.push(0);

    var ipad = [], opad = [];
    for (var i=0;i<64;i++) { ipad.push(keyBytes[i]^0x36); opad.push(keyBytes[i]^0x5c); }

    var inner = sha256(ipad.concat(strToBytes(message)));
    var innerBytes = [];
    for (var i=0;i<8;i++){
      innerBytes.push((inner[i]>>>24)&0xff,(inner[i]>>>16)&0xff,(inner[i]>>>8)&0xff,inner[i]&0xff);
    }
    var outer = sha256(opad.concat(innerBytes));
    return outer.map(function(v){
      return ('00000000'+v.toString(16)).slice(-8);
    }).join('');
  }

  // ── HMAC signing secret (obfuscated split) ────────────────────────────────
  // The real secret is assembled at runtime from these parts — not stored as a plain string.
  var _p = ['E','c','o','m','L','a','b','T','h','m','S','e','c','2','0','2','6','!','@','#'];
  var _SIGN_SECRET = _p.join('');

  // ── Cache helpers ─────────────────────────────────────────────────────────
  function readCache() {
    try {
      var raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (Date.now() > obj.expires) return null;
      return obj;
    } catch(e) { return null; }
  }

  function writeCache(valid, plan) {
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify({
        valid: valid,
        plan: plan || 'standard',
        expires: Date.now() + CFG.cacheTTL,
        graceExpires: Date.now() + CFG.graceTTL,
      }));
    } catch(e) {}
  }

  function readGraceCache() {
    try {
      var raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (obj.valid && Date.now() < obj.graceExpires) return obj;
      return null;
    } catch(e) { return null; }
  }

  // ── Overlay ───────────────────────────────────────────────────────────────
  function showOverlay(msg) {
    if (document.getElementById('elxr-license-wall')) return;
    document.body.style.overflow = 'hidden';
    var el = document.createElement('div');
    el.id = 'elxr-license-wall';
    el.style.cssText = [
      'position:fixed','top:0','left:0','width:100%','height:100%',
      'background:#fff','z-index:2147483647','display:flex',
      'align-items:center','justify-content:center','flex-direction:column',
      'font-family:-apple-system,BlinkMacSystemFont,Segoe UI,sans-serif',
      'text-align:center','padding:40px','box-sizing:border-box'
    ].join(';');
    el.innerHTML = [
      '<svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#e53e3e" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">',
      '<rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>',
      '</svg>',
      '<h2 style="margin:20px 0 10px;font-size:22px;font-weight:700;color:#1a202c">EcomLab Theme — License Required</h2>',
      '<p style="color:#718096;font-size:15px;max-width:420px;line-height:1.6;margin:0 0 24px">' + (msg || 'This theme requires a valid license key to operate.') + '</p>',
      '<p style="color:#a0aec0;font-size:13px">Go to <strong>Online Store → Themes → Customize → Theme Settings → License</strong> and enter your key.</p>',
      '<a href="https://theme.brainboxecomlab.com" target="_blank" style="margin-top:24px;padding:12px 28px;background:#1a202c;color:#fff;text-decoration:none;border-radius:6px;font-size:14px;font-weight:600">Get a License →</a>',
    ].join('');
    el.addEventListener('click', function(e){ e.stopPropagation(); });
    document.body.appendChild(el);
  }

  // ── API verify ────────────────────────────────────────────────────────────
  function verifyWithAPI(attempt) {
    attempt = attempt || 0;
    var ts = String(Date.now());
    var payload = LICENSE_KEY + '|' + SHOP + '|' + ts;
    var sig = hmacSHA256(_SIGN_SECRET, payload);

    var url = CFG.api + '/licenses/verify'
      + '?licenseKey=' + encodeURIComponent(LICENSE_KEY)
      + '&shop='       + encodeURIComponent(SHOP)
      + '&ts='         + encodeURIComponent(ts)
      + '&sig='        + encodeURIComponent(sig);

    fetch(url, { method: 'GET', cache: 'no-store' })
      .then(function(r){ return r.json(); })
      .then(function(data) {
        if (data && data.valid === true) {
          writeCache(true, data.plan);
          // Valid — do nothing, store runs normally
        } else {
          writeCache(false);
          setTimeout(function(){
            showOverlay(data && data.message);
          }, CFG.overlayDelay);
        }
      })
      .catch(function() {
        // Network error — check grace cache before showing overlay
        var grace = readGraceCache();
        if (grace && grace.valid) {
          // Previously verified store — grant offline grace period
          return;
        }
        if (attempt < CFG.maxRetries) {
          setTimeout(function(){ verifyWithAPI(attempt + 1); }, CFG.retryDelay);
        } else {
          // No grace, no retries left — block
          setTimeout(function(){
            showOverlay('Unable to verify license. Please check your internet connection.');
          }, CFG.overlayDelay);
        }
      });
  }

  // ── Corrupt template guard ────────────────────────────────────────────────
  // Called when license is definitively revoked server-side
  function handleRevoked() {
    writeCache(false);
    showOverlay('Your EcomLab Theme license has been revoked. Contact support at theme.brainboxecomlab.com');
  }

  // ── Main entry ────────────────────────────────────────────────────────────
  function init() {
    // No license key at all → show overlay immediately
    if (!LICENSE_KEY || LICENSE_KEY.trim() === '') {
      setTimeout(showOverlay, CFG.overlayDelay);
      return;
    }

    // Check local cache first
    var cache = readCache();
    if (cache) {
      if (!cache.valid) {
        setTimeout(showOverlay, CFG.overlayDelay);
      }
      // valid cache → pass through, but still reverify in background quietly
      // (after a random delay to spread server load)
      var jitter = Math.random() * 5000;
      setTimeout(verifyWithAPI, jitter);
      return;
    }

    // No cache → must call API
    verifyWithAPI();
  }

  // Run after DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
